module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-paypal-express-checkout/index.js
// module id = 863
// module chunks = 0